// removed by extract-text-webpack-plugin
module.exports = {"bold":"app-pages-RegisterComplete-__style___2SamA","logoButton":"app-pages-RegisterComplete-__style___26EgS","noOffset":"app-pages-RegisterComplete-__style___31YAZ","img-progress":"app-pages-RegisterComplete-__style___9sgTc","img-description":"app-pages-RegisterComplete-__style___2sfVu","splitter":"app-pages-RegisterComplete-__style___3FEP1","text":"app-pages-RegisterComplete-__style___anW4e","title":"app-pages-RegisterComplete-__style___3Nf7H","link":"app-pages-RegisterComplete-__style___3neVE"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/RegisterComplete/style.css
// module id = 2475
// module chunks = 0